export enum Catalog {
  CHANGE_QUANTITY = "changeQuantity",
  CHANGE_SORT_DIRECTION = "changeSortDirection",
  SET_QUERY = "setQuery",
  SET_PRODUCTS = "setProducts",
  SET_QUANTITY = "setQuantity",
  SET_BREADCRUMB_CATEGORIES = "setBreadCrumbCategories",
  SET_CATEGORIES = "setCategories",
  SET_META = "setPageMeta",
  SET_REQUEST = "setRequest",
  SET_FETCHING = "setFetching",
  SET_ERROR = "setPageError",
}

export enum SortDirections {
  ASC = "asc",
  DESC = "desc",
}

export const MetaDefault = {
  breadcrumbs: [
    { url: "/", icon: "mdi-home", name: "Главная" },
    { url: "/catalog", name: "Каталог" },
  ],
  h1: "Каталог",
  title: "MTK - Каталог",
};
